import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Row, Button } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

import { setRUTFormat } from '../../../../shared/utils';
import PersonalData from '../PersonalData';
import CaseManagement from '../CaseManagement';

const CaseSummaryCard = ({
  state,
  loadingInfoCase,
  createEmail,
  onHandleScore,
  isAuditor,
  showCaseManagement,
  params,
}) => {
  const handleOpenEmail = () => {
    window.open(createEmail, 'name', 'width=600,height=400');
  };

  return (
    <Card className="cardo_botton" style={{ height: 'auto' }}>
      <CardBody style={{ padding: '0px 10px' }}>
        <div className="profile_casos card col-md-12" style={{ flexWrap: 'wrap', justifyContent: 'flex-start', padding: '10px 0px' }}>
          <div className="profile_info col-md-12" style={{ display: 'flex', flexWrap: 'wrap' }}>
            {loadingInfoCase && <Skeleton count={1} height={40} />}
            <div className="col-md-4 ml-2">
              <h5 className="label_autofin">{state?.names || 'sin nombre'} {state?.paternalSurname || 'sin apellido'}</h5>
              <h5>{state?.rut === '' ? 'sin rut' : setRUTFormat(state.rut)}</h5>
            </div>
            {!isAuditor && (
              <div className="profile_info_calls col-md-7" style={{ justifyContent: 'flex-start', marginTop: '2%' }}>
                <Row>
                  <Button
                    className="asignar button_details button_profile_detail"
                    type="submit"
                    onClick={handleOpenEmail}
                    id="added"
                  >
                    <span style={{ color: '#646777' }}>Enviar correo</span>
                  </Button>
                  <button className="crm-close-case-btn" disabled={state?.status?.value === 'closed'} onClick={onHandleScore}>
                    <span style={{ color: '#646777' }}>Cerrar caso</span>
                  </button>
                </Row>
              </div>
            )}
          </div>
          <PersonalData state={state} />
          {showCaseManagement && <CaseManagement state={state} params={params} />}
        </div>
      </CardBody>
    </Card>
  );
};

CaseSummaryCard.propTypes = {
  state: PropTypes.shape({
    names: PropTypes.string,
    paternalSurname: PropTypes.string,
    rut: PropTypes.string,
    status: PropTypes.shape({
      value: PropTypes.string,
    }),
    isRef: PropTypes.bool,
  }).isRequired,
  loadingInfoCase: PropTypes.bool,
  createEmail: PropTypes.string,
  onHandleScore: PropTypes.func.isRequired,
  isAuditor: PropTypes.bool.isRequired,
  showCaseManagement: PropTypes.bool.isRequired,
  params: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

CaseSummaryCard.defaultProps = {
  loadingInfoCase: false,
  createEmail: '',
  params: '',
};

export default CaseSummaryCard;
